import { Context, Controller } from '@hotwired/stimulus';

export default class TrainingsNudgeController extends Controller {
  private shouldBlock = false;

  constructor(context: Context) {
    super(context);

    this.preventNavigation = this.preventNavigation.bind(this);
  }

  connect(): void {
    this.shouldBlock = true;
    window.addEventListener('beforeunload', this.preventNavigation);
  }

  disconnect(): void {
    window.removeEventListener('beforeunload', this.preventNavigation);
  }

  public markAsNudged() {
    this.shouldBlock = false;
  }

  private preventNavigation(event: Event) {
    if (!this.shouldBlock) {
      return;
    }

    event.preventDefault();

    // Included for legacy support, e.g. Chrome/Edge < 119
    event.returnValue = true;
  }
}
